import AsyncStorage from '@react-native-async-storage/async-storage';

const DAY = 86400000;
export type PromptState = { firstVisit: number; lastVisit: number; days: number; lastPrompt: number; disabled: boolean };
const key = (scope: string) => `@eleplan/feedback-prompt/${scope}`;

export function nextVisit(previous: Partial<PromptState>, now: number): PromptState {
  const sameDay = previous.lastVisit && Math.floor(previous.lastVisit / DAY) === Math.floor(now / DAY);
  return {
    firstVisit: previous.firstVisit ?? now, lastVisit: now,
    days: Math.min(30, (previous.days || 0) + (sameDay ? 0 : 1)),
    lastPrompt: previous.lastPrompt || 0, disabled: previous.disabled === true,
  };
}
export function promptDue(state: PromptState, now = Date.now()): boolean {
  return !state.disabled && state.days >= 3 && now - state.firstVisit >= 7 * DAY
    && (!state.lastPrompt || now - state.lastPrompt >= 30 * DAY);
}
export async function recordVisit(scope: string): Promise<PromptState | null> {
  try {
    const raw = await AsyncStorage.getItem(key(scope));
    const state = nextVisit(raw ? JSON.parse(raw) || {} : {}, Date.now());
    await AsyncStorage.setItem(key(scope), JSON.stringify(state));
    return state;
  } catch { return null; } // If frequency limits cannot be read, do not prompt.
}
export async function savePromptState(scope: string, state: PromptState): Promise<void> {
  await AsyncStorage.setItem(key(scope), JSON.stringify(state));
}
